import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/reporting/cash_flow/cash_fow';
import { getMe } from "../../../../../../redux/modules/cuenta/login";
import CashFlowEdit from './CashFlowEdit';
import './CashFlow.css'

const mstp = state => {
    return { ...state.cash_flow }
};

const mdtp = {
    ...actions, getMe
};

export default connect(mstp, mdtp)(CashFlowEdit)
